import React from 'react';
import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from 'extended-oxygen-elements';
import { useSelector } from 'react-redux';
import { getFlags } from '../../../../../../state/Flags';

type Props = {
  buttons: {
    label: string;
    onClick: () => void;
    icon: React.ReactNode;
    isDisabled?: boolean;
  }[];
  handleButtonClick: () => void;
  menuState: any;
};

type Flags = {
  rotaVsTimesheetHoursReport?: boolean;
};

export const AllReportsListDropDown = ({
  buttons,
  handleButtonClick,
  menuState,
}: Props) => {
   const flags: Flags = useSelector(getFlags)  || {} ;
   let rotaVsTimesheetHoursReportFF = false;
    if ('rotaVsTimesheetHoursReport' in flags) {
      rotaVsTimesheetHoursReportFF = !!flags.rotaVsTimesheetHoursReport;
    }

    return (
      <Menu {...menuState}>
        {buttons.map((option) => {
          const isRotaVsTimesheet = option.label === 'Rota vs timesheet hours';

          if (isRotaVsTimesheet && !rotaVsTimesheetHoursReportFF) {
            return null;
          } else {
            return (
              <li key={`option-item-${option.label}`}>
                <MenuItem
                  component="div"
                  onClick={() => {
                    option.onClick();
                    handleButtonClick();
                  }}
                  disabled={option.isDisabled}
                >
                  <ListItemIcon>{option.icon}</ListItemIcon>
                  <ListItemText>{option.label}</ListItemText>
                </MenuItem>
              </li>
            );
          }
        })}
      </Menu>
    );
};